import * as React from 'react'
import { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectAllRoles } from '@user/store/roles/slice'
import CircularProgress from '@mui/material/CircularProgress'
import { NoResultsCard } from '@sales-center/components'
import { RoleCard } from './RoleCard'
import { useDeleteRole, useReadRole } from '@user/store/roles/hooks'
import { RoleFormModel } from '@user/store/roles/typings'

interface Props {
  loading: boolean
  setEditRole: (model?: RoleFormModel) => void
}

export const RoleList: FC<Props> = ({ loading, setEditRole }) => {
  const roles = useSelector(selectAllRoles)

  const { role, execute: onEdit } = useReadRole()
  const { execute: onDelete } = useDeleteRole()

  useEffect(() => {
    setEditRole(role)
  }, [role, setEditRole])

  return (
    <>
      {roles.length === 0 ? (
        loading ? (
          <CircularProgress />
        ) : (
          <NoResultsCard label="No roles added yet" />
        )
      ) : (
        roles.map((r, i) => (
          <RoleCard key={i} role={r} onEdit={onEdit} onDelete={onDelete} />
        ))
      )}
    </>
  )
}
RoleList.displayName = 'RoleList'
